<template>
  <div class="system-builder__main-upgrades--item" :class="{ 'selected-upgrade': isActive}"
       @click="toggleSelectedUpgrade">
    <div class="system-builder__main-upgrades--item-image">
      <slot name="upgrade-image"></slot>
    </div>

    <div class="system-builder__main-upgrades--item-content">
      <slot name="upgrade-description"></slot>
    </div>

    <div class="system-builder__main-upgrades--item-status" :class="{ 'upgrade-selected-status': isActive}">
      <span v-if="isActive">Selected</span>
      <span v-else>Unselected</span>
    </div>
  </div>
</template>

<script>
  import store from '../../store/index'

  export default {
    name: 'upgradeItem',
    props: ['id', 'isActive'],
    data () {
      return {
        sharedState: store.state,
        active: this.isActive,
        upgradeId: this.id
      }
    },
    methods: {
      toggleSelectedUpgrade: function () {
        var upgradeId = this.upgradeId

        // Update store with updated attributes
        store.updateSelectedAttribute(upgradeId)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UpgradeItem.vue?0a49386e